import _ from 'underscore';

import {Table} from 'notebook/tables/TableConstants';

export function countSelectors(documentParts: Array<{table?: Table | null}>): Record<string, number> {
  const usageCounts: {[selectorId: string]: number} = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const part of Array.from(_.filter(documentParts, (documentPart) => documentPart.table != null))) {
    for (const row of Array.from(part.table!.table)) {
      for (const cell of Array.from(row)) {
        const {selectorId} = cell;
        if (selectorId == null) {
          continue;
        }
        if (!usageCounts[selectorId]) {
          usageCounts[selectorId] = 0;
        }
        usageCounts[selectorId] += 1;
      }
    }
  }
  return usageCounts;
}
